
import { defineComponent, PropType } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@/utils/i18n-validators'
import { Role, getAllowedRoleGrant, getHemisLevelFromRole } from '@/utils/role-utils'
import { useSession } from '@/composables/auth'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'

export default defineComponent({
  props: {
    userRole: { type: String as PropType<Role>, required: false }
  },
  emits: ['update:visible', 'authAdded'],
  setup() {
    let { user } = useSession()
    return {
      v$: useVuelidate(),
      user,
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        name: '',
        email: '',
        role: ''
      }
    }
  },
  validations() {
    return {
      formData: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        role: {
          required
        }
      }
    }
  },
  computed: {
    closable(): boolean {
      return true
    },
    roleOptions(): object[] {
      if (!this.userRole) {
        return []
      }
      const grantableRoles = getAllowedRoleGrant(this.userRole)
      return grantableRoles.map((role) => ({
        key: role,
        label: this.$t('roles.' + role.toLowerCase())
      }))
    },
    selectedRole: {
      get(): object | null {
        if (!this.formData.role) {
          return null
        }
        let selectedOption = null
        for (let option of this.roleOptions) {
          const opt: any = option
          if (opt.key == this.formData.role) {
            selectedOption = option
            break
          }
        }
        return selectedOption
      },
      set(newRole: any) {
        if (newRole != null) {
          this.formData.role = newRole.key
        }
      }
    }
  },
  methods: {
    setVisible(visible: boolean) {
      this.dialogVisible = visible
      this.$emit('update:visible', visible)
      if (!visible) {
        this.reset()
      }
    },
    hide() {
      this.setVisible(false)
    },
    show() {
      this.setVisible(true)
    },
    reset() {
      this.formData.name = ''
      this.formData.email = ''
      this.formData.role = ''
      this.v$.$reset()
    },
    async changePassword() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      try {
        const bid = await this.getCurrentBuildingId()
        if (bid) {
          await hemisphereService.addBuildingAuthorizations(bid, {
            name: this.formData.name,
            email: this.formData.email,
            hemis_level: getHemisLevelFromRole(this.formData.role)
          })
          this.$toast.add({
            severity: 'success',
            summary: 'Le partage a été créé.',
            life: 3000
          })

          this.$emit('authAdded')
          this.hide()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
})
